import { render, staticRenderFns } from "./SearchUserFeedbackByItem.vue?vue&type=template&id=974c682a"
import script from "./SearchUserFeedbackByItem.vue?vue&type=script&lang=js"
export * from "./SearchUserFeedbackByItem.vue?vue&type=script&lang=js"
import style0 from "./SearchUserFeedbackByItem.vue?vue&type=style&index=0&id=974c682a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports